import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { ContentWrapper, Panel } from '@checkmarx/cx-ui';
import RightMasterACPanel from './rightMasterAccessControlPanel';
import classNames from 'classnames';
import styles from './style.scss';


@inject('translationsStore', 'routesStore') @observer
export default class MasterACContainer extends Component {

    t = this.props.translationsStore.translate;

    componentDidMount() {
        this.props.routesStore.setSettingsSelectedTabId(this.props.tabId);
    }

    render() {

        return(
            <ContentWrapper className='content-wrapper'>
                <Panel className={classNames('content-left-hand', styles.contentLeftHandSetting)}>
                    <div className='master-ac-left-title' data-cy='master-ac-screen'>
                        {this.t('MASTER_ACCESS_CONTROL')}
                    </div>
                    <div style={{whiteSpace: 'pre-line'}} className='.master-ac-right-sub-title'>
                        {this.t('MASTER_ACCESS_CONTROL_DEFINE')}
                        {`\n${this.t('MASTER_ACCESS_CONTROL_DESCRIPTION')}`}
                        <br/><br/>
                        {`${this.t('NOTES')}:`}
                        {`\n• ${this.t('MASTER_ACCESS_CONTROL_REACHABLE')}`}
                        {`\n• ${this.t('MASTER_ACCESS_CONTROL_WHEN_ACTIVE')}`}
                    </div>
                </Panel>
                <Panel className='content-right-hand'>
                    <RightMasterACPanel/>
                </Panel>
            </ContentWrapper>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/masterAccessControl/index.js